import { TWidgetImagesPreloadMap } from "./types";

export const INITIAL_STATE: TWidgetImagesPreloadMap = {
  VERIFIED_LANGUAGES: false,
  KAGGLE: false,
  DEV_COMMUNITY: false,
};
